import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { getCmsPopularTrips } from "../../../app/api/getCmsPopularTrips";
import { getFavouriteDeparturesBestPrices } from "../../../app/api/getFavouriteDeparturesBestPrices";
import { IPopularTripsForHomePage } from "../../../Orchestrator/Types/Interface/ICmsPopularTrip";
import {
    IBestPricePriceItem,
    IFavouriteDeparturesBestPricesResponse,
} from "../../../Orchestrator/Types/Interface/IFavouriteDeparturesBestPrices";

class GetPopularTripsAction extends BaseAction<IPopularTripsForHomePage[], void> {
    protected override deduplicate = true;
    override async run(): Promise<IPopularTripsForHomePage[] | null> {
        const listOfPopularTrips: IPopularTripsForHomePage[] = [];
        try {
            const popularTripsResponse = await getCmsPopularTrips();
            if (popularTripsResponse.status !== "ok" || !popularTripsResponse.answer) {
                return listOfPopularTrips;
            }

            const popularTrips = popularTripsResponse.answer;
            if (!popularTrips.data || popularTrips.data.length === 0) {
                return listOfPopularTrips;
            }

            const bestPricesResponse: any = await getFavouriteDeparturesBestPrices(false);
            const payload: IFavouriteDeparturesBestPricesResponse | undefined =
                bestPricesResponse?.status === "ok" ? bestPricesResponse.answer : undefined;
            const currency = payload?.currency || null;
            const lowestByRoute = buildLowestByRoute(payload?.prices || []);

            for (const data of popularTrips.data) {
                const from = data?.origin?.code || null;
                const to = data?.destination?.code || null;
                if (!from || !to) continue;

                const lowest = lowestByRoute.get(routeKey(from, to));
                listOfPopularTrips.push({
                    origin: data.origin,
                    destination: data.destination,
                    imageFrom: data?.origin?.image || null,
                    imageTo: data?.destination?.image || null,
                    price: lowest ? lowest.price : null,
                    currency: lowest ? currency : null,
                    date: lowest ? lowest.date : null,
                });
            }

            updateRecoilState("popularTripsForHomePageAtom", listOfPopularTrips);
        } catch (error: any) {
            console.error("Error fetching popular trips:", error);
        } finally {
            updateRecoilState("popularTripsLoadedAtom", true);
        }
        return listOfPopularTrips;
    }
}

function routeKey(origin: string, destination: string): string {
    return `${origin}->${destination}`;
}

function buildLowestByRoute(prices: IBestPricePriceItem[]): Map<string, IBestPricePriceItem> {
    const map = new Map<string, IBestPricePriceItem>();
    for (const p of prices) {
        const key = routeKey(p.origin, p.destination);
        const existing = map.get(key);
        if (!existing || p.price < existing.price) {
            map.set(key, p);
        }
    }
    return map;
}

export const getPopularTripsAction = new GetPopularTripsAction();
